import { Activity } from 'react';
import { SchemaFilterType, Table } from '@ui/src';
import {
  marginListColumns,
  marginListColumnsLabels,
  allMarginListColumnsLabels,
} from '../../../hoc/common/tariff/variables/margins';
import MarginsTop from './parts/margins-top';
import Card from '../card/card';
import { CustomMarginTypes } from './types';

import cn from './styles.module.css';

const CustomMargins = ({
  allMarginsVisible,
  setAllMarginsVisible,
  setSelectedCurrency,
  currencies,
  currenciesList,
  selectedCurrency,
  showMoreCurrencies,
  setShowMoreCurrencies,
  setMenuOnFocus,
  customMargins,
  customerId,
  tariffId,
  customMarginsPagination,
  menuOnFocus,
  setSeletedMarginId,
  setMarginPanelIsOpen,
  marginsIsLoading,
  onAllMarginsCurrencyFilter,
  formattedMarginsData,
  errorList,
  filters,
  onMarginsFilterChange,
  filtersComponent,
  handleSubmit,
  marginsIsFetching,
  allMarginsErrorsList,
  allMarginFilters,
  onAllMarginsFilterChange,
  allMarginsFitlersComponent,
  allMarginsHandleSubmit,
  setPage,
  customMarginsErrorsList,
}: CustomMarginTypes) => (
  <Card
    className={cn.marginCard}
    transparent={!marginsIsLoading}
    isLoading={marginsIsLoading}
  >
    <MarginsTop
      allMarginsVisible={allMarginsVisible}
      setAllMarginsVisible={setAllMarginsVisible}
      setSelectedCurrency={setSelectedCurrency}
      currencies={currencies}
      currenciesList={currenciesList}
      showMoreCurrencies={showMoreCurrencies}
      selectedCurrency={selectedCurrency}
      onAllMarginsCurrencyFilter={onAllMarginsCurrencyFilter}
      setShowMoreCurrencies={setShowMoreCurrencies}
      setMenuOnFocus={setMenuOnFocus}
      menuOnFocus={menuOnFocus}
    />
    <div
      className={`${!customMargins ? cn.marginsTable : ''} ${
        cn.marginTableWrapper
      }`}
    >
      <Activity mode={allMarginsVisible ? 'hidden' : 'visible'}>
        <Table
          columns={marginListColumns}
          data={formattedMarginsData || []}
          sort={{}}
          onSort={() => {}}
          error={customMarginsErrorsList || errorList}
          filters={filters}
          columnsLabels={marginListColumnsLabels}
          tableFormClassName={
            !customMargins?.length ? cn.customMarginsEmptyTableForm : ''
          }
          tableClassName={cn.marginsTable}
          tableTopClassName={cn.marginTableTop}
          onRowClick={(id) => {
            setSeletedMarginId(id);
            setMarginPanelIsOpen(true);
          }}
          onFilterChange={(values) => onMarginsFilterChange(values)}
          tableBodyClassName={`${
            !customMargins?.length ? cn.marginsEmptyTable : ''
          } ${cn.marginTableBody}`}
          filtersComponent={filtersComponent}
          handleSubmit={handleSubmit}
          isLoading={marginsIsFetching || marginsIsLoading}
          take="20"
        />
      </Activity>
      <Activity mode={allMarginsVisible ? 'visible' : 'hidden'}>
        <Table
          columns={marginListColumns}
          data={formattedMarginsData || []}
          sort={{}}
          onSort={() => {}}
          tableTopClassName={cn.marginTableTop}
          error={customMarginsErrorsList || allMarginsErrorsList}
          filters={allMarginFilters}
          columnsLabels={allMarginListColumnsLabels}
          tableClassName={cn.marginsTable}
          onRowClick={(id) => {
            setSeletedMarginId(id);
            setMarginPanelIsOpen(true);
          }}
          onFilterChange={(values) => onAllMarginsFilterChange(values)}
          tableBodyClassName={`${
            !customMargins?.length ? cn.marginsEmptyTable : ''
          } ${cn.marginTableBody}`}
          filtersComponent={allMarginsFitlersComponent}
          handleSubmit={allMarginsHandleSubmit}
          isLoading={marginsIsFetching || marginsIsLoading}
          setPage={(data) =>
            setPage({
              ...data,
              filters: {
                ...allMarginFilters,
                currencyFromId: {
                  value: [selectedCurrency as string],
                  type: SchemaFilterType.STRING,
                },
                organizationId: {
                  value: [customerId as string],
                  type: SchemaFilterType.STRING,
                },
                tariffId: {
                  value: [tariffId as string],
                  type: SchemaFilterType.STRING,
                },
              },
            })
          }
          take="20"
          pagination={customMarginsPagination}
        />
      </Activity>
    </div>
  </Card>
);

export default CustomMargins;
